var Acre = "アクレ";
var Alagoas = "アラゴアス";
var Amazonas = "アマゾナス";
var Bahia = "バイーア";
var Pernambuco = "ペルナンブコ";
var Roraima = "ロライマ";
var Sergipe = "セルジッペ";
var Tocantins = "トカンティンス";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "アマパ",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "セアラ",
	"Federal District": "連邦直轄区",
	"Espírito Santo": "エスピリトサント",
	"Goiás": "ゴイアス",
	"Maranhão": "マラニャン",
	"Mato Grosso": "マトグロッソ",
	"Mato Grosso do Sul": "マトグロッソドスル",
	"Minas Gerais": "ミナスジェライス",
	"Pará": "パラー",
	"Paraíba": "パライバ",
	"Paraná": "パラナ",
	Pernambuco: Pernambuco,
	"Piauí": "ピアウイ",
	"Rio de Janeiro": "リオデジャネイロ",
	"Rio Grande do Norte": "リオグランデドノルテ",
	"Rio Grande do Sul": "リオグランデドスル",
	"Rondônia": "ロンドニア",
	Roraima: Roraima,
	"Santa Catarina": "サンタカタリーナ",
	"São Paulo": "サンパウロ",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
